import createContext from '@atlassian/react-ufo/interaction-id-context';

export type { InteractionIDContextType } from '@atlassian/react-ufo/interaction-id-context';
export {
	getInteractionId,
	useInteractionId,
	DefaultInteractionID,
} from '@atlassian/react-ufo/interaction-id-context';
export default createContext;
